/* eslint-disable no-underscore-dangle */
import { NgFor, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule , MatPseudoCheckboxModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Observable } from 'rxjs';
import { Validations } from '../..';

@Component({
    selector: 'formly-multiselect-all',
    styleUrls: ['./multiselect-all.component.less'],
    templateUrl: './multiselect-all.component.html',
    standalone: true,
    imports: [
        MatOptionModule,
        MatPseudoCheckboxModule,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        NgTemplateOutlet,
        NgFor,
    ],
})
export class FormlyMultiselectAllComponent extends FieldType<FormlyFieldConfig> implements OnInit {
	selectOptions: any[] = [];

	toggleSelectAll() {
		this.formControl.setValue(this.value.length !== this.selectOptions.length ? this.selectOptions.map((x) => x.value) : []);
	}

	get state() {
		if (this.value.length > 0) {
			return this.value.length !== this.selectOptions.length ? 'indeterminate' : 'checked';
		}

		return '';
	}

	getDisplay(): string {
		return this.value.length === this.selectOptions.length
			? 'All'
			: this.selectOptions
					.filter((x) => this.value.includes(x.value))
					.map((x) => x.label)
					.join(', ');
	}

	public ngOnInit(): void {
		if (this.props.options instanceof Array) {
			this.selectOptions = this.props.options;
		} else if (this.props.options instanceof Observable) {
			this.props.options.subscribe((result) => {
				this.selectOptions = result;
			});
		}

		if (this.props.defaultAll === true) {
			this.value = this.selectOptions.map((x) => x.value);
		}
	}

	public getErrorMessage(): string {
		if (this.formControl.errors?.required) {
			return Validations.requiredValidationMessage({}, this.field);
		}

		return '';
	}

	handleCheckboxSelection(value: number): void {
		if (typeof this.props.changeMoreCheckboxs == 'function') {
			this.props.changeMoreCheckboxs(value);
		}
	}
}
